import React from "react";

const IconButtonsGroup = props => {
    const {children} = props;
    return (
        <span className="ch-icons-group">{children}</span>
    )
}

export default IconButtonsGroup;